import React from "react";
import ReactDOM from "react-dom";
// Bootstrap MUST be imported before App (and any custom CSS) so our own styles
// reliably override Bootstrap defaults (e.g. .btn-primary). Importing it after
// App let Bootstrap win the specificity tie and turned custom buttons blue.
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";

// Must match the gtag ID in public/index.html and the Firebase project's
// measurementId (project cedar-18da3) so SPA route events land in the SAME GA4
// property. A mismatched ID here silently sends all navigation data to a dead
// property.
const trackingId = "G-0M1S0Y2WMR";
ReactGA.initialize(trackingId);

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Marketing pages are Puppeteer-prerendered to React's EXACT output, so we
// hydrate them (no flash). Article pages ship hand-rendered static HTML for
// crawlers (window.__STATIC_PRERENDER__), which does NOT match React's tree —
// hydrating it would duplicate the content, so we clean-render (React replaces
// the static body). Non-prerendered routes have an empty #root and just render.
const staticPrerender =
  typeof window !== "undefined" && window.__STATIC_PRERENDER__;
if (rootElement.hasChildNodes() && !staticPrerender) {
  ReactDOM.hydrate(app, rootElement);
} else {
  // Drop the crawler-only static body first; React 18's legacy render does not
  // reliably clear existing children, which would leave a duplicate copy.
  if (staticPrerender) rootElement.innerHTML = "";
  ReactDOM.render(app, rootElement);
}
